import React, { useState, useEffect, useCallback } from 'react';

import styles from './monitorization.module.scss';
import '../../theme/global.scss';

import { useLocation } from 'react-router-dom';
import { IoCloudDownload, IoAddOutline } from 'react-icons/io5';

import {
  downloadRaport,
  getMonitorization
} from '../../network/monitorization';
import { IMonitorization, IMeasure } from '../../utils/interfaces/interfaces';
import { buildMonitorizationMessage, prettyDate } from '../../utils/strings';
import CTable from '../../components/table/table';
import {
  getMeasureDocuments,
  getMeasuresDecision
} from '../../network/measure';
import CButton from '../../components/button/button';
import CModal from '../../components/modal/modal';
import AddMeasure from '../../components/forms/add_measure';
import EditObservations from '../../components/forms/edit_observations';
import EditMeasure from '../../components/forms/edit_measure';
import AddMonitorization from '../monitorizations/add_monitorization';
import { columnsMeasures } from '../../utils/tables';
import { Skeleton } from 'antd';
import CTimeline from '../../components/timeline/timeline';
import { Space } from '../../components/utils/utils';
import { enableLoader } from '../../components/loader/loader';
import { measuresTypes } from '../../types/measures';
import LitigiiModal from '../../components/forms/add_litigii';
import { useGetCurrentUserQuery } from '../../api';

const initialDecision: IMonitorization = {
  date: new Date(),
  createdAt: new Date(),
  number: '',
  id: 0,
  uniqueFileNumber: '',
  name: '',
  fileCount: 0,
  measureCount: 0,
  expiredMeasureCount: 0,
  expiredMeasureCountToday: 0,
  type: measuresTypes.MEASURES
};

const Monitorization = () => {
  const [openedModal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [observationsModal, openObservations] = useState(false);
  const [documentsModal, openDocuments] = useState(false);
  const [litigiiModal, openLitigii] = useState(false);
  const [editMonitorization, setModalEditMonitorization] = useState(false);

  const [selectedMeasure, setMeasure] = useState({} as IMeasure);
  const [documents, setDocuments] = useState([]);
  // const [litigii, setLitigii] = useState([]);
  const [loading, setLoading] = useState(false);

  const [monitorization, setMonitorization] =
    useState<IMonitorization>(initialDecision);

  const [data, setList] = useState([]);
  const location = useLocation();
  const [state, setState] = useState({ id: 0, editingMode: false });
  // const [uniqueNumber, setUniqueNumber] = useState('');
  const { data: user } = useGetCurrentUserQuery();

  const getDecisionInfo = useCallback(() => {
    if (location.state) {
      setState(location.state as any);
    } else {
      window.history.back();
    }
    // eslint-disable-next-line
  }, [location.state]);

  useEffect(() => {
    if (loading) {
      enableLoader();
    }
  }, [loading]);

  useEffect(() => {
    if (state.id !== 0)
      getMonitorization(state.id).then(({ data }) => {
        setMonitorization(data.decision);
      });
  }, [state.id]);

  useEffect(() => {
    getDecisionInfo();
  }, [getDecisionInfo]);

  // useEffect(() => {
  //   setLoading(true);
  //   if (state.id !== 0) getDocuments();

  //   // eslint-disable-next-line
  // }, [state.id]);

  useEffect(() => {
    if (state.id !== 0)
      getMeasuresDecision(state.id).then(({ data }) =>
        setList(data.decisionMeasures)
      );
  }, [state.id]);

  const getDocuments = async (measure = selectedMeasure) => {
    await getMeasureDocuments(measure.id)
      .then(({ data }) => {
        setDocuments(data.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // const submitUniqueNumber = (event: React.MouseEvent) => {
  //   event.preventDefault();

  //   if (uniqueNumber && uniqueNumber.length > 0) {
  //     updateMonitorization({
  //       date: monitorization.date,
  //       uniqueFileNumber: uniqueNumber,
  //       number: monitorization.number,
  //       name: monitorization.name,
  //       id: monitorization.id
  //     }).then(() => {
  //       getMonitorization(state.id).then(({ data }) => setMonitorization(data));
  //       notify('Monitorizarea s-a actualizat cu succes', 'success');
  //     });
  //   } else {
  //     notify('Numarul este invalid', 'warning');
  //   }
  // };

  const handleDocuments = async (measure: IMeasure) => {
    setMeasure(measure);
    await getDocuments(measure);
    openDocuments(true);
  };

  const getLitigii = async (measure: IMeasure) => {
    setMeasure(measure);
    openLitigii(true);
    // getLitigiiByMeasure(measure.id).then(({ data }) => setLitigii(data));
  };

  return (
    <div className={styles.container}>
      {!loading && (
        <>
          <div className={styles.rowInfo}>
            <div className='column align-start'>
              <p className='subheading-dark bold'>{`Monitorizarea ${
                monitorization.name
              } cu numărul ${monitorization.number} creată pe ${prettyDate(
                monitorization.createdAt
              )}`}</p>
              <Space vertical={'10px'} />
              <p className='body-dark'>
                {buildMonitorizationMessage(
                  monitorization.type,
                  monitorization.fileCount,
                  monitorization.measureCount,
                  monitorization.expiredMeasureCount,
                  monitorization.expiredMeasureCountToday
                )}
              </p>
            </div>
            {state && state.editingMode && (
              <CButton
                type='button'
                label='Editează monitorizare'
                onClick={() => setModalEditMonitorization(true)}
              />
            )}
          </div>
          {/* {state &&
            state.editingMode &&
            monitorization.uniqueFileNumber &&
            monitorization.uniqueFileNumber.length === 0 && (
              <>
                <p className='body-dark error'>
                  Această monitorizare nu are un număr de dosar unic.
                </p>
                <div className='row-auto justify-start '>
                  <CInput
                    placeholder='număr dosar unic'
                    label=''
                    id='number'
                    type='number'
                    name='number'
                    value={uniqueNumber}
                    onChange={e => setUniqueNumber(e.target.value)}
                  />
                  <Space horizontal='30px' />
                  <CButton
                    type='submit'
                    label='Salvează'
                    onClick={submitUniqueNumber}
                  />
                </div>
              </>
            )} */}
          {/* {monitorization.uniqueFileNumber &&
            monitorization.uniqueFileNumber.length !== 0 && (
              <>
                <p className='subheading-dark bold'>Numarul Dosarului unic</p>
                <p className='body-dark'>{monitorization.uniqueFileNumber}</p>
                <Space vertical='4vh' />
              </>
            )} */}
          <div className={styles.table}>
            {state && state.editingMode && (
              <CButton
                type='button'
                onClick={() => setModal(true)}
                label={<IoAddOutline />}
                className={styles.edit}
              />
            )}
            <CButton
              type='button'
              onClick={() =>
                downloadRaport(
                  monitorization.id,
                  `Monitorizare ${monitorization.name} cu numarul ${monitorization.number}`
                )
              }
              label={<IoCloudDownload />}
              className={styles.download}
            />
            <CTable
              data={data}
              columns={columnsMeasures(
                monitorization,
                styles,
                openObservations,
                handleDocuments,
                getDocuments,
                getLitigii,
                setMeasure,
                state.editingMode ? setEditModal : null,
                user
              )}
            />
          </div>

          {/* <p className='subheading-dark bold'>Istoric fișiere adăugate</p>
          {documents && documents.length === 0 && (
            <p className='subheading-dark faded'>
              Nu au fost adaugate inca documente.
            </p>
          )} */}
          <CModal opened={documentsModal} openModal={openDocuments}>
            {loading ? (
              <Skeleton active />
            ) : (
              <CTimeline documents={documents} />
            )}
          </CModal>

          <CModal opened={litigiiModal} openModal={openLitigii}>
            <LitigiiModal
              measure={selectedMeasure}
              readOnly={!state.editingMode}
            />
          </CModal>

          <CModal opened={openedModal} openModal={setModal}>
            <AddMeasure
              type={monitorization.type}
              idMonitorization={monitorization.id}
              callback={() => {
                getMeasuresDecision(state.id).then(({ data }) =>
                  setList(data.decisionMeasures)
                );
                setModal(false);
              }}
            />
          </CModal>
          <CModal opened={editModal} openModal={setEditModal}>
            <EditMeasure
              type={monitorization.type}
              idMonitorization={monitorization.id}
              selectedMeasure={selectedMeasure}
              callback={() => {
                getMeasuresDecision(state.id).then(({ data }) =>
                  setList(data.decisionMeasures)
                );
                getDocuments();
                setEditModal(false);
              }}
              documents={documents}
            />
          </CModal>
          <CModal opened={observationsModal} openModal={openObservations}>
            <EditObservations
              readOnly={!state.editingMode}
              observations={selectedMeasure.observations}
              idMeasure={selectedMeasure.id}
              callback={() => {
                getMeasuresDecision(state.id).then(({ data }) =>
                  setList(data.decisionMeasures)
                );

                openObservations(false);
              }}
            />
          </CModal>
          <CModal
            opened={editMonitorization}
            openModal={setModalEditMonitorization}
          >
            <AddMonitorization
              edit
              monitorization={monitorization}
              id={monitorization.id}
              callback={() => {
                setModalEditMonitorization(false);
                getMeasuresDecision(state.id).then(({ data }) =>
                  setList(data.decisionMeasures)
                );
                getMonitorization(state.id).then(({ data }) =>
                  setMonitorization(data.decision)
                );
              }}
            />
          </CModal>
        </>
      )}
    </div>
  );
};

export default Monitorization;
